/**
 * De 'Anders, namelijk...'-optie van een meerkeuzevraag.
 *
 * HOE HET IS OPGESLAGEN: als een gewone `MultipleQuestionOptions`-regel waarvan
 * `Option` letterlijk 'other' is. Dat is geen mooie vorm — een echte antwoord-
 * optie die toevallig 'other' heet zou ermee samenvallen — maar het is wél de
 * vorm die de vragenlijst-module al jaren gebruikt (QuestionnaireField.jsx,
 * open/FieldType.jsx). Eén afwijkende markering erbij verzinnen zou betekenen
 * dat dezelfde vraag op twee plekken anders werkt.
 *
 * Daarom staat de afspraak hier één keer opgeschreven in plaats van als losse
 * string door de code. Wordt de markering ooit vervangen door een echt veld,
 * dan is dit de plek.
 *
 * NOG NIET OVERAL: de vragenlijst-module vergelijkt nog met de kale string
 * 'other'. Die migratie is niet meegenomen — zie docs/inbox.md.
 * AI-CONTEXT: See docs/pitfalls.md#dev-mirrored-constant-guarded-only-by-a-comment
 */

/** Wat er in `Option` staat om de regel als 'anders' te markeren. */
const OTHER_OPTION_VALUE = 'other'

/** Wat de gebruiker ervan te zien krijgt — in de bouwer én op het formulier. */
const OTHER_OPTION_LABEL = 'Anders, namelijk...'

/**
 * @param {{Option?: string}|string} [option] - Een optiedocument of de kale waarde
 * @returns {boolean}
 */
const isOtherOption = (option) => {
    const value = typeof option === 'string' ? option : option?.Option
    return value === OTHER_OPTION_VALUE
}

/**
 * Of er in deze lijst al een 'anders'-optie zit. Er hoort er maar één te zijn:
 * twee vrije tekstvelden onder één vraag is voor de invuller onnavolgbaar.
 *
 * @param {Array<{Option?: string}>} [options]
 * @returns {boolean}
 */
const hasOtherOption = (options) => (options || []).some(isOtherOption)

/**
 * De opties die een echte, vaste keuze zijn — dus zonder 'anders'.
 *
 * @param {Array<{Option?: string}>} [options]
 * @returns {Array<{Option?: string}>}
 */
const concreteOptions = (options) => (options || []).filter((o) => !isOtherOption(o))

export { OTHER_OPTION_VALUE, OTHER_OPTION_LABEL, isOtherOption, hasOtherOption, concreteOptions }
